<template>
  <div class="qmyx-container advisor-select ">
    <div class="title">
      请选择接待置业顾问
    </div>

    <div v-for="(item, index) in advisorData" :key="index">
      <div class="advisor-list-item" @click="handleCheck(item)">
        <img
          class="radio"
          style="width:20px;height:20px"
          :src="isChecked(item)"
        />
        <div class="name">
          {{ item.salesName }}
        </div>
        <div class="phone">
          {{ item.salesTel }}
        </div>
      </div>
      <div
        style="height: 1px;
    border-bottom: 1px solid #efefef;margin-left: 52px;margin-right: 24px;"
      ></div>
    </div>
    <div class="fixed-bottom">
      <div class="submit-btn" @click.stop="handleSubmit">确 定</div>
    </div>
  </div>
</template>
<script>
import { createNamespacedHelpers } from "vuex";
import { Toast } from "mint-ui";
const { mapState, mapMutations } = createNamespacedHelpers("qmyx");
import { getSaleAdvisor } from "./api";

export default {
  data() {
    return {
      checkedItem: {},
      updateUser: "打掉费", //更新人
      updateTime: "2020-03-15", //更新时间
      advisorData: [] //顾问数据
    };
  },

  activated() {
    this.checkedItem = {};
    this.handleLoadData();
  },
  computed: {
    ...mapState(["selectAdvisor"])
  },
  methods: {
    ...mapMutations(["saveSelectAdvisor"]),
    async handleLoadData() {
      const id = (this.$route.params || {}).id || "";
      if (id) {
        const { result = [] } = await getSaleAdvisor(id);
        this.advisorData = result;
      }
      if (this.selectAdvisor != null) {
        this.checkedItem = this.selectAdvisor;
      }
    },
    isChecked(item) {
      return this.checkedItem &&
        this.checkedItem.id &&
        item.id === this.checkedItem.id
        ? "https://assets.rurushishi.com/yq-rs-make/huafa/img/radio-select.png"
        : "https://assets.rurushishi.com/yq-rs-make/huafa/img/radio.png";
    },
    handleCheck(item) {
      this.checkedItem = item;
    },
    handleSubmit() {
      if (!this.checkedItem) {
        Toast("请选择一个接待员");
        return;
      }
      this.saveSelectAdvisor(this.checkedItem);
      this.$router.back();
    }
  }
};
</script>
<style scoped lang="scss">
.advisor-select {
  padding-bottom: 2rem;
  .title {
    font-size: 0.3rem;
    color: #4a4a4a;
    letter-spacing: 0;
    margin-top: 0.36rem;
    margin-left: 0.48rem;
    margin-bottom: 0.12rem;
  }

  .advisor-list-item {
    height: 0.9rem;
    margin-left: 0.48rem;
    margin-right: 0.42rem;
    display: flex;
    align-items: center;
    .radio {
      width: 0.4rem;
      height: 0.4rem;
    }
    .name {
      font-size: 0.3rem;
      color: #222222;
      letter-spacing: 0;
      text-align: left;
      margin-left: 0.16rem;
      flex: 1;
    }
    .phone {
      font-size: 0.3rem;
      color: #999999;
      letter-spacing: 0;
      text-align: right;
    }
    .line {
      margin-left: 1.04rem;
      border-bottom: 0.02rem solid #efefef;
    }
  }
}
</style>
